/* eslint-disable prefer-template */
/* eslint-disable default-param-last */
import { actionType } from 'Config/actionTypes';

const INITIAL_STATE = {
  data: [],
  isLoading: false,
  responseTime: 0,
  isError: false,
  msgError: '',
};
export const headcountBreakdownCSVReducer = (state = INITIAL_STATE, action) => {
  const defaultActionTypes = [
    actionType.HEADCOUNT_BREAKDOWN_BRANCH_CSV,
    actionType.HEADCOUNT_BREAKDOWN_ORGANIZATION_CSV,
    actionType.HEADCOUNT_BREAKDOWN_JOB_LEVEL_CSV,
    actionType.HEADCOUNT_BREAKDOWN_GRADE_CSV,
    actionType.HEADCOUNT_BREAKDOWN_EMPLOYMENT_STATUS_CSV,
    actionType.HEADCOUNT_BREAKDOWN_GENDER_CSV,
    actionType.HEADCOUNT_BREAKDOWN_AGE_CSV,
    actionType.HEADCOUNT_BREAKDOWN_LATEST_EDUCATION_CSV,
    actionType.HEADCOUNT_BREAKDOWN_RELIGION_CSV,
    actionType.HEADCOUNT_BREAKDOWN_PTKP_STATUS_CSV,
  ];

  const loadingActionTypes = defaultActionTypes.map(row => `${row}_LOADING`);
  const resultActionTypes = defaultActionTypes.map(row => `${row}_RESULT`);
  const failedActionTypes = defaultActionTypes.map(row => `${row}_FAILED`);

  switch (true) {
    case loadingActionTypes.includes(action.type):
      return {
        ...state,
        isLoading: true,
      };
    case resultActionTypes.includes(action.type):
      return {
        ...state,
        data: action.result.data,
        responseTime: action.result.responseTime,
        isLoading: false,
        isError: false,
        msgError: '',
      };
    case failedActionTypes.includes(action.type):
      return {
        ...state,
        isError: true,
        msgError: action.err,
        isLoading: false,
      };
    default:
      return state;
  }
};
